interface SourceInfo {
  name: string;
  city: string;
  country: string;
}

const SOURCE_DISPLAY: Record<string, SourceInfo> = {
  CANTONFAIR: { name: 'Canton Fair', city: 'Guangzhou', country: 'China' },
  'CANTON-FAIR': { name: 'Canton Fair', city: 'Guangzhou', country: 'China' },
  HKTDC: { name: 'HKTDC', city: 'Hong Kong', country: 'Hong Kong' },
  'GLOBAL-SOURCES': { name: 'Global Sources', city: 'Hong Kong', country: 'Hong Kong' },
  GLOBALSOURCES: { name: 'Global Sources', city: 'Hong Kong', country: 'Hong Kong' },
  GSEXHIBITIONS: { name: 'Global Sources Exhibition', city: 'Hong Kong', country: 'Hong Kong' },
  ODOO_PARTNERS: { name: 'Odoo Partner Network', city: '', country: '' },
  ODOO_CUSTOMERS: { name: 'Odoo Customer Network', city: '', country: '' },
};

export interface PrimarySource {
  code: string;
  displayName: string;
  city: string;
  country: string;
}

export function getPrimarySource(sources: string[]): PrimarySource | null {
  if (!sources || sources.length === 0) return null;
  // Pick the first source code that has a known display entry, fallback to first
  const recognized = sources.find((s) => SOURCE_DISPLAY[s.toUpperCase()] ?? SOURCE_DISPLAY[s]);
  const code = recognized ?? sources[0];
  // Strip trailing digits from codes like CANTONFAIR139 → CANTONFAIR
  const baseCode = code.replace(/\d+$/, '');
  const entry =
    SOURCE_DISPLAY[code.toUpperCase()] ??
    SOURCE_DISPLAY[code] ??
    SOURCE_DISPLAY[baseCode.toUpperCase()] ??
    SOURCE_DISPLAY[baseCode];
  return {
    code,
    displayName: entry?.name ?? baseCode,
    city: entry?.city ?? '',
    country: entry?.country ?? '',
  };
}
